/**
 * Servicio para la precarga de recursos críticos en la aplicación
 */

// Lista de recursos críticos a precargar - rutas basadas en análisis de red
const criticalResources = [
  // Recursos estáticos principales
  '/favicon.ico',
  '/flags/spain.svg',
  '/flags/uk.svg',
  '/logo-fucal.webp',
  '/logo-uemc.webp',
  '/titulo-zaquiel.webp',
  '/zaquiel-fondo-1920x1080.webp',

  // Imágenes de opciones de capítulo
  '/images/comic.webp',
  '/images/articulo.webp',
  '/images/cofre.webp',

  // Fondos de capítulos (botones del listado de cómics)
  '/api/comics/num-01/background.webp',
  '/api/comics/num-02/background.webp',
  '/api/comics/num-03/background.webp',
  '/api/comics/num-04/background.webp',
  '/api/comics/num-05/background.webp',
  '/api/comics/num-06/background.webp',
  '/api/comics/num-07/background.webp',
  '/api/comics/num-08/background.webp',
  '/api/comics/num-09/background.webp',

  // Fuentes - según análisis de red
  '/main.2ed6367.css', // Contiene referencias a las fuentes
  '/comicsfreeBold.216ee5b5d0ba6e5d9e.woff2',
  '/comicsfreeRegular.edf69f0b1969139a.woff2'
];

// Estado de la precarga
let isPreloading = false;

/**
 * Precarga una imagen específica
 * @param {string} url - URL de la imagen a precargar
 * @param {Function} onProgress - Callback para el progreso
 * @returns {Promise<boolean>} - Promesa que se resuelve cuando la imagen está cargada (true si éxito, false si error)
 */
const preloadImage = (url, onProgress) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      if (onProgress) onProgress(url, true);
      resolve(true);
    };
    img.onerror = () => {
      if (onProgress) onProgress(url, false);
      resolve(false);
    };
    img.src = url;
  });
};

/**
 * Precarga un recurso genérico (CSS, fuentes, etc)
 * @param {string} url - URL del recurso a precargar
 * @param {Function} onProgress - Callback para el progreso
 * @returns {Promise<boolean>} - Promesa que se resuelve cuando el recurso está cargado
 */
const preloadResource = (url, onProgress) => {
  return new Promise((resolve) => {
    fetch(url)
      .then(response => {
        if (onProgress) onProgress(url, response.ok);
        resolve(response.ok);
      })
      .catch(() => {
        if (onProgress) onProgress(url, false);
        resolve(false);
      });
  });
};

/**
 * Precarga todos los recursos críticos
 * @param {Function} onProgress - Callback para actualizar el progreso (recibe url y éxito)
 * @param {Function} onComplete - Callback que se ejecuta al completar la precarga
 * @returns {Promise<void>}
 */
const preloadAllResources = async (onProgress, onComplete) => {
  // Si ya estamos precargando, no iniciar otra vez
  if (isPreloading) {
    console.log("Precarga ya en proceso, ignorando llamada duplicada");
    return;
  }

  try {
    isPreloading = true;
    console.log("Iniciando precarga de recursos");

    const promises = criticalResources.map(url => {
      if (/\.(jpg|jpeg|png|gif|webp|ico|svg)$/i.test(url)) {
        return preloadImage(url, onProgress);
      } else {
        return preloadResource(url, onProgress);
      }
    });

    // Espera a que se carguen todos los recursos (o fallen)
    await Promise.all(promises);
    console.log("Proceso de precarga finalizado");

    if (onComplete) onComplete();
  } catch (error) {
    console.error("Error general en precarga:", error);
    if (onComplete) onComplete();
  } finally {
    isPreloading = false;
  }
};

/**
 * Servicio de precarga para la aplicación
 */
const preloadService = {
  preloadAllResources,
  criticalResources
};

export default preloadService; 